module.exports = __webpack_public_path__ + "static/media/mishandling-sensitive-information.aadeaeae.svg";